module.exports = __webpack_public_path__ + "static/media/ki.645af307.svg";